import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {LoginService} from '../../../login-service';
import Swal from 'sweetalert2';
import { ImageuploadService } from '../../../Imageupload.service';
@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss'],
  providers:[LoginService]
})
export class EmailComponent implements OnInit {

  SendMailCHeck:boolean=false;
  usersList: any;

  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  UsersCount=[];
  SearchList:any;
  
  currentpage: number=1;
  checked=[];
  searchText: any;
  adminUserType:string;
  usersListDetails:any;
  menuName: any;
  menuData: any;
  menuID: any;
  userID: string;
  roleID: string;
  SelectedUsers:any;
  MenuPermissions: string;
  rolesList: any;
  selectedoption: any;
  selectedemails=[];
  groupselect:boolean=false;
  countriesList: any;
  country:any;
  documentsList: any;
  filterusersList: any=[];
  filterdocsList: any;
  errormsg: string;
  errormsg1: string;
  subject:any;
  description:any;
  errormsg2: any;
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p: number;
  count: number;
 savefilter: any;
  //edituser
  



  constructor(private loginService:LoginService,private router: Router,public imageservice: ImageuploadService) { 
    this.userID=localStorage.getItem("userID");
    this.roleID=localStorage.getItem("roleID");
    this.adminUserType=localStorage.getItem("userTypeid");
    this.MenuPermissions=localStorage.getItem("MenuPermissions");
    this.GetMenusByUserType(3);
  }

  ngOnInit(): void {
    this.loginService.getselectpage(10)
    this.GetUsers();
    this.GetRoles();
    this.getCountries();
  }

GetRoles(){
  this.loginService.GetRoles(this.adminUserType).subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
            this.rolesList=JSON.parse(JSON.stringify(data));
let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

if(filteRole.length>0){
  this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);

}
});
}
GetMenusByUserType(userTypeID){
  this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
      {
  
  data = JSON.parse(data['_body']);
  this.menuData=JSON.parse(JSON.stringify(data));

  let tempdata=this.menuData;
 
  this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='emails');

  if(this.menuData.length>0)
    {
  this.menuName=this.menuData[0]["menu_name"];
  this.menuID=this.menuData[0]["menu_id"];
    }
  

    
  
      });
      }



delete(ID,type) {
  
  if(type=="delete")
  {
  const json={
    userid:ID,
    param:"d"
  }
  this.loginService.DeleteUser(json).subscribe(data => { 
    if(type=='delete'){
    //  Swal.fire("Deleted successfully")
     this.loginService.showSuccess("Deleted successfully!",'');    
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  }
  })

}

else if(type=="deactivate")
{
  const json={
    userid:ID,
    param:"n"
  }
  
  this.loginService.DeleteUser(json).subscribe(data => { 
    
      // Swal.fire("User deactivated successfully") 
      this.loginService.showSuccess("User deactivated successfully!",'');
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
else if(type=="activate")
{
  const json={
    userid:ID,
    param:"y"
  }

  this.loginService.DeleteUser(json).subscribe(data => { 
    
      // Swal.fire("User activated successfully") 
      this.loginService.showSuccess("User activated successfully!",'');
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}
}

DeleteUser(user,type){
  
if(type=="delete")
{
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to delete this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}
else if(type=="deactivate")
{
 
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to deactivate this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })
}
else if(type=="activate")
{
  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to activate this user:' + user.user_name,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(user.id,type);//
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })
}
}
changepagination(page:number){
  this.count=this.rowsOnPage
  console.log(this.rowsOnPage)
  this.loginService.getselectpage(this.rowsOnPage)
  this.loginService.getPager(this.usersListDetails.length, page);
  this.setPage(page)
}

setPage(page: number) {
this.p=page;
  this.pager = this.loginService.getPager(this.usersListDetails.length, page);
  this.count=this.pager.pageSize
  this.pagedItems = this.usersListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.usersList = this.usersListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);

}

Searchtext(){
  this.usersList = this.savefilter;
  
      let tempCompany = this.usersList.filter(
        (item) => {
          return (
            (item.user_name !== null && item.user_name.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.user_type !== null && item.user_type.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
            (item.email !== null && item.email.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
          );
        }
  
      );
      this.usersList = tempCompany;
      this.assigndynamicarray(tempCompany)
      // if(this.searchText==""){
      //   this.GetUsers();
      //   this.assigndynamicarray(this.usersList)
      // }
      if(this.searchText !== ""){
        this.usersListDetails = tempCompany;
        this.setPage(1);
    }else{
        this.usersListDetails = this.savefilter;      
        this.assigndynamicarray(this.usersList)
  
        this.setPage(1);
    }
     
  
}
GetUsers()
{
  this.loginService.GetUsers(this.adminUserType).subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
            this.usersList=JSON.parse(JSON.stringify(data));
            this.usersListDetails=this.usersList;
            this.savefilter=this.usersListDetails;
            this.assigndynamicarray(this.usersList)
            if(this.usersListDetails.length>0){
              this.setPage(1);
            }
            
    });
}
assigndynamicarray(userslist)
{
  this.dynamicRows=10
  this.rowsOnPageSet=[];
  this.rowCount = userslist.length;
  console.log(this.rowCount,this.dynamicRows)
  while (this.dynamicRows < this.rowCount) {
    this.rowsOnPageSet.push(this.dynamicRows);
    this.dynamicRows = this.dynamicRows + 10;
    console.log(this.rowsOnPageSet)
  }
  if (!this.rowsOnPageSet.includes(this.rowCount))
    this.rowsOnPageSet.push(this.rowCount);
  if (this.rowsOnPageSet.length === 1) {
    if (this.rowsOnPageSet[0] <= 10)
      this.rowsOnPage = this.rowsOnPageSet[0];
  }
  this.rowsOnPage = this.rowsOnPageSet[0];
}
email(email){
this.UsersCount=email;
}
checkedtrue(u){
  
  const json={
    userid:u.id
  }
  this.loginService.ReactivateUser(json).subscribe(data => { 
  
    this.GetUsers();
    setTimeout(() => {
     // this.message = "";
    }, 1000);
  
  })
}


getCountries(){
    
  this.loginService.GetCountries().subscribe(data=>
    {
      data = JSON.parse(data['_body']);
      this.countriesList = JSON.parse(JSON.stringify(data));
    });
 
}

SendIndividualMail(){
  if(this.UsersCount.length==0 ||this.subject==""||this.description==""|| this.subject==undefined||this.description==undefined){
 
    this.errormsg2="*Please enter all the details"
  return;
}

else{
  
  this.errormsg2=""
 this.SendMailCHeck=false;
  this.loginService.SendMail(this.UsersCount,this.subject,this.description).subscribe(data=>{
      this.loginService.showSuccess("Mail Sent Successfuly","");
      this.SendMailCHeck=true;
      this.UsersCount=[];
      this.subject="";
      this.description="";
  })
}
}

GetSelectedUsers(){
      
  this.SelectedUsers=this.UsersCount;
}

filterRegion(countryname){

this.filterusersList=[];
  this.loginService.GetLegalDocuments().subscribe(data=>
      {  
        data = JSON.parse(data['_body']);
        this.documentsList =  JSON.parse(JSON.stringify(data));
       
        this.filterdocsList=this.documentsList.filter(x=>x.Country.toString()===countryname.toString());
        this.loginService.GetUsers(this.adminUserType).subscribe(data=>
          {  
            data = JSON.parse(data['_body']);
                  this.usersList=JSON.parse(JSON.stringify(data));
                  if(countryname=="All"){
                    this.filterusersList=this.usersList;
                  }
                  else{
        for(var i=0;i<this.filterdocsList.length;i++){
          var filteredusers=this.usersList.filter(x=>x.id==this.filterdocsList[i].userid && x.is_active=='y')
          if(filteredusers.length>0){
            this.filterusersList.push(filteredusers[0])
          }
        }
      }
        if(this.filterusersList.length==0){
          this.errormsg="No users available in this region";
        }
        else{
          this.errormsg=" "
        }
      });
      });
 
}

selectgroup(){
  this.UsersCount=[];
  let useremails:any;
  useremails=[];
  this.loginService.GetUsers(this.adminUserType).subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
            this.usersList=JSON.parse(JSON.stringify(data));
  if(this.selectedoption=="All"){
     useremails=this.filterusersList;
     if(useremails.length>0){
       this.errormsg1=""
     }
  }
  else if(this.selectedoption=="Initiator"){
    useremails=this.filterusersList.filter(x=>x.user_type_id==1)
    if(useremails.length==0){
      this.errormsg1="No initiators availbale in this region"
    }
    else{
      this.errormsg1=" "
    }
  }
  else if(this.selectedoption=="Collaborator"){
    useremails=this.filterusersList.filter(x=>x.user_type_id==2)
    if(useremails.length==0){
      this.errormsg1="No collaborators availbale in this region"
    }
    else{
      this.errormsg1=" "
    }
  }
  for(var i=0;i<useremails.length;i++)
  this.UsersCount.push(useremails[i].email)
})
}
//edituser methods
}
